let itemId = 0;
export default {
  mappLastId(item) {
    if (item) {
      if (item.length > 1) {
        let lastItem = item[item.length - 1];
        if (lastItem) {
          itemId = lastItem.id;
        }
      } else {
        if (item[0].applicationId) {
          itemId = item[0].id;
        } else {
          if (item[0].children) {
            this.mappLastId(item[0].children);
          } else {
            itemId = item.id;
          }
        }
      }
    }
    return itemId;
  }
};
